import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import Chip, { ChipProps } from './Chip';

const styles = ({
  palette: {
    common: { white },
  },
  custom: {
    palette: { colorSuccess },
  },
}: Theme) =>
  createStyles({
    root: {
      color: white,
      fontSize: 10,
      height: 20,
      textTransform: 'uppercase',
      // TODO unify with theme colors as mockups use colors that we don't have defined
      // https://www.figma.com/file/lWC5H3y5FUdHh3cJg3NLds/Messaging-Activity?node-id=331%3A138
      background: colorSuccess,
    },
  });

export interface ChipSuccessProps extends Omit<ChipProps, 'classes'>, WithStyles<typeof styles> {
  label: React.ReactNode;
}

const ChipSuccess: React.FC<ChipSuccessProps> = ({ classes, className, ...rest }) => (
  <Chip className={classnames(classes.root, className)} dense {...rest} />
);

export default withStyles(styles)(ChipSuccess);
